import { render, staticRenderFns } from "./formAddMaintenance.vue?vue&type=template&id=12648ce2&"
import script from "./formAddMaintenance.vue?vue&type=script&lang=js&"
export * from "./formAddMaintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports